export default "__VITE_ASSET__e4cc8d26__"